var map = {
	"./add-wallet.vue": [
		8870,
		3776
	],
	"./admAffiliate.vue": [
		2736,
		5800,
		2831
	],
	"./admDownloadTaxpnl.vue": [
		7133,
		5800,
		5183
	],
	"./admReferral.vue": [
		9934,
		5800,
		2032
	],
	"./affiliateReporting.vue": [
		7429,
		8531
	],
	"./check-esign.vue": [
		370,
		5800,
		9492
	],
	"./customer-invoice.vue": [
		2052,
		5800,
		1591
	],
	"./customer-payin-payout.vue": [
		8181,
		1578
	],
	"./customer-payments.vue": [
		3952,
		5800,
		3340
	],
	"./customer-search.vue": [
		6318,
		5800,
		2357
	],
	"./customer-subs.vue": [
		1673,
		5800,
		1981
	],
	"./discount-master.vue": [
		4413,
		5800,
		8
	],
	"./download-holdings.vue": [
		386,
		6869
	],
	"./epiFunds.vue": [
		4131,
		3217
	],
	"./exchange-info.vue": [
		9793,
		5800,
		4854
	],
	"./finance-payin.vue": [
		5993,
		5800,
		2759
	],
	"./finance-payout.vue": [
		9658,
		5800,
		1547
	],
	"./finance-subscription.vue": [
		1764,
		5800,
		9607
	],
	"./ipo.vue": [
		14,
		5634,
		2225
	],
	"./manage-affiliate.vue": [
		1075,
		5800,
		6208
	],
	"./manage-reallocation.vue": [
		2898,
		5800,
		4554
	],
	"./nri-taxation.vue": [
		148,
		5800,
		2298
	],
	"./product-master.vue": [
		6291,
		5800,
		1392
	],
	"./refresh-cache.vue": [
		2495,
		7850
	],
	"./resetPassword.vue": [
		9915,
		5634,
		8878
	],
	"./support-wallet.vue": [
		2198,
		1930
	],
	"./suspended-affiliate.vue": [
		240,
		5800,
		1997
	],
	"./transactionDiscrepancy.vue": [
		2623,
		5634,
		1527
	],
	"./userTrades.vue": [
		7662,
		5800,
		5634,
		6039
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2446;
module.exports = webpackAsyncContext;